<div class="row mt-2">
    <div class="col-md-12">
        <div class="btn-group">
            <button type="button" class="btn btn-outline-primary" (click)="RedirectToList()"><span class="fa fa-reply"></span></button>
        <button type="button" class="btn btn-outline-primary" (click)="Save()"><span class="fa fa-save"></span></button>
        </div>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-12">
        <yt-drzava-update #baseUpdate></yt-drzava-update>
    </div>
</div>